export enum EMessageBubbleTailVariant {
  Triangle = 'triangle',
  Diamond = 'diamond',
}

export enum EMessageBubbleSizeVariant {
  Sm = 'sm',
  Md = 'md',
  Lg = 'lg',
}

export enum EMessageBubbleToneVariant {
  Elevated = 'elevated',
  Muted = 'muted',
}
